
export default {
  props: {
    elements: {
      type: Array,
      default() {
        return []
      }
    },
    imagepath: {
      type: String,
      required: true
    },
    version: {
      type: String,
      default: 'v1'
    },
    startLeft: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classCol1: 'col-xs-24 col-md-7 position-relative hide-xs-only hide-sm-only',
      classCol2: 'col-xs-24 col-md-15 text-center image'
    }
  },
  created() {
    if (this.version !== 'v1') {
      this.classCol1 = 'col-xs-22 col-md-10 position-relative'
      this.classCol2 = 'col-xs-22 col-md-10 position-relative text-center image'
    }
  },
  methods: {
  }
}
